import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Select, MenuItem } from 'WeployDesignLanguage/Select';

import InfoOutlinedIcon from 'LegacyWeployDesignLanguage/icons/InfoOutlinedIcon';

import { mapPaymentTerms } from '../../../containers/weployer/timesheets/mappers';

const StyledA = styled.a`
    ${props => props.theme.typography.subtitle1};
    color: ${props => props.theme.colors.text.primary};
`;

const StyledInfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

const StyledInfoOutlinedIcon = styled(InfoOutlinedIcon)`
  color: ${props => props.theme.colors.text.primary};
  padding: ${props => props.theme.spacing[2]} ${props => props.theme.spacing[3]};
`;

const StyledPaymentTermWrapper = styled.div`
  margin-top: ${props => props.theme.spacing[2]};
`;

const StyledInfoText = styled.p`
  ${props => props.theme.typography.body1};
  color: ${props => props.theme.colors.text.primary};
`;

const StyledBoldInfoText = styled.p`
  ${props => props.theme.typography.subtitle1};
  color: ${props => props.theme.colors.text.primary};
`;

const PaymentTermSelection = ({
  onPaymentTermChange,
  paymentTermId,
  paymentTerms,
  editBillingPath,
  showEditBillingPath,
}) => (
  <StyledPaymentTermWrapper>
    <StyledBoldInfoText>This is the first timesheet payment for the organisation, please select the payment terms</StyledBoldInfoText>

    <Select
      label="Payment terms*"
      onChange={(event) => { onPaymentTermChange(event.target.value, paymentTerms); }}
      required
      value={paymentTermId}
      width="250px"
    >
      <MenuItem disabled>Select a payment term</MenuItem>
      {
        mapPaymentTerms(paymentTerms).map(({ id, name }) => (
          <MenuItem key={id} value={id}>{name}</MenuItem>
        ))
      }

    </Select>
    <StyledInfoContainer>
      <StyledInfoOutlinedIcon />
      <StyledInfoText>
        Organisations have the option for longer payment terms by taking advantage of the Weploy
        credit facility. A credit surcharge will be applied to your invoices depending on the
        option you pick.&nbsp;
        Admin users can adjust the payment terms for the organisation { showEditBillingPath && <>in <StyledA href={editBillingPath}>Billing</StyledA></> }
      </StyledInfoText>
    </StyledInfoContainer>
  </StyledPaymentTermWrapper>
);

PaymentTermSelection.propTypes = {
  onPaymentTermChange: PropTypes.func.isRequired,
  paymentTermId: PropTypes.string,
  paymentTerms: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    chargePercentage: PropTypes.number.isRequired,
    days: PropTypes.number.isRequired,
  })).isRequired,
  editBillingPath: PropTypes.string.isRequired,
  showEditBillingPath: PropTypes.bool.isRequired,
};

PaymentTermSelection.defaultProps = {
  paymentTermId: '',
};


export default PaymentTermSelection;
